<template>
  <b-modal v-model="show" size="lg" scrollable :no-close-on-esc="true" :no-close-on-backdrop="true">
    <div class="container-fluid modal-wrap">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
            <v-select
                label="name"
                v-model="formula.province"
                :filterable="false"
                :options="provinces"
                @search="onProvinceSearch"
                @change="onProvinceChange"
            >
              <span slot="no-options">{{$t("messages.combo.empty")}}</span>
            </v-select>
            <div class="red" v-if="$v.formula.province.id.$error">
              {{$t("realEstate.validation.province")}}
            </div>
          </div>
        </div>
        <div class="col-12" v-if="reference">
          <div class="table-wrapper">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="table-wrap">Туман</th>
                  <th v-for="(field) in reference.fields" :key="field.id">{{field.name}}</th>
                </tr>
              </thead>
              <tbody v-if="!loading && formula.items && formula.items.length > 0">
              <tr v-for="(item, index) in formula.items" :key="index">
                <td>
                  <span v-if="item.region">{{index + 1}}. {{item.region.name}}</span>
                </td>
                <template v-for="(field) in reference.fields">
                  <td :key="field.id" v-if="item.data[field.code]">
                    <numeric-input :precision="2" v-model="item.data[field.code].value" class="input-wrap"></numeric-input>
                  </td>
                </template>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <button class="all-btn delete-btn float-right ml-2" :disabled="processing" @click="onClose">
          {{$t('action.cancel')}}
        </button>
        <button class="all-btn add-btn float-right" @click="save" :disabled="processing">
          {{ $t('action.save') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import bModal from 'bootstrap-vue/es/components/modal/modal';
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
import {required} from 'vuelidate/lib/validators';
import initFilterModel from "@/shared/filter";
export default {
  name: "FormulaEdit",
  components: {
    'b-modal': bModal
  },
  directives: {
    'b-modal': bModalDirective
  },
  props: {
    reference: {
      type: Object
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      processing: false,
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      formula: {
        province: null,
        code: this.$props.reference.code,
        name: this.$props.reference.name,
        items: [
          {
            region: null,
            data: {}
          }
        ]
      },
      provinces: [],
      regions: []
    }
  },
  validations: {
    formula: {
      province: {
        id: {
          required
        }
      }
    }
  },
  methods: {
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return;
      }

      this.processing = true
      this.$http.post('/cadastre-building-field-reference-formula', this.formula)
          .then(res => {
            if (res.data && res.data.status === 'SUCCESS') {
              this.show = false;
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.common.saved'),
                type: 'success'
              });
              this.$eventBus.$emit('formulaChanged');
              this.formula = this.initBaseData()
            }
            this.processing = false
          }, err => {
            console.log(err);
            this.processing = false
          });
    },
    onClose() {
      this.show = false
    },
    initBaseData() {
      return {
        province: null,
        code: this.$props.reference.code,
        name: this.$props.reference.name,
        items: [
          {
            region: null,
            data: {}
          }
        ]
      }
    },
    initData() {
      let items = []
      for (let i = 0; i < this.regions.length; i++) {
        items.push({
          region: this.regions[i],
          data: this.getReferenceMap()
        })
      }
      this.formula.items = items
    },
    getReferenceMap() {
      let refMap = {}
      if(this.$props.reference.hasOwnProperty('fields') && this.$props.reference.fields.length > 0) {
        this.$props.reference.fields.forEach(item => {
          if(item.hasOwnProperty('code')) {
            refMap[item.code] = { value: null }
          }
        })
      }
      return refMap
    },
    init() {
      this.provinces = [];
      this.filterProvince.search = '';

      this.loading = true
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            if (res.data && res.data.data) {
              this.provinces = res.data.data;
            }
            this.loading = false
          }, err => {
            console.log(err);
            this.loading = false
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.loading = true
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            if (res.data && res.data.data) {
              this.provinces = res.data.data;
            }
            loading(false);
            this.loading = false
          }, err => {
            console.log(err);
            this.loading = false
          });
    },
    onRegionSearch() {
      this.regions = [];
      this.filterRegion.provinceId = (this.formula.province && this.formula.province.id) ? this.formula.province.id : 0;
      this.loading = true
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            if (res.data && res.data.data) {
              this.regions = res.data.data;
              this.initData()
            }
            this.loading = false
          }, err => {
            console.log(err);
            this.loading = false
          });
    },
    onProvinceChange() {
      this.onRegionSearch()
    }
  },
  created() {
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.init();
    this.$eventBus.$on("showFormulaEditModal", (data) => {
      if (data && data.code === this.reference.code) {
        this.show = true
      }
    })
  },
  // watch: {
  //   formula: {
  //     handler: function (val) {
  //       console.log("watch formula = ", val)
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped>
 .modal-wrap {
   min-height: 500px;
 }

 .input-wrap {
   min-width: 60px;
 }

 .table-wrap {
   min-width: 180px;
 }
</style>